import { DatiqCellLocationPosition } from './datiq-cell-location.enum';
import { DatiqGeoSuggestionSchema } from '../../../models';
import { z } from 'zod';

export const DatiqCellLocationSchema = z.object({
    geoInfo: DatiqGeoSuggestionSchema,
    location: z.nativeEnum(DatiqCellLocationPosition),
});

export interface IDatiqCellLocation
    extends z.infer<typeof DatiqCellLocationSchema> {}
